module.exports = __webpack_public_path__ + "static/media/Avatar.9b7aa6d8.svg";